import { Swiper, Navigation, Autoplay } from "swiper/bundle";
export default class SwiperPartners {
    constructor() {
        console.log('%c👍🏼 Swiper Partners', 'color: yellow');
        
        this.swiperPartners = document.querySelectorAll('.swiper-partners')

        console.log(' this.swiperPartners',  this.swiperPartners);
    }
    init() {
        this.swiperPartners.forEach((module, i) => {

            const elem = module.querySelector('.swiper--partners')
            console.log(' module',  module);
            const nextButton = module.querySelector('.swiper-button-next')
            const prevButton = module.querySelector('.swiper-button-prev')
            new Swiper(elem, {
                slidesPerView: 1,
                loop: false,
                spaceBetween: 30,
                speed: 1001,
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton,
                }
            });   
        })
    }
}